module.exports = __webpack_public_path__ + "static/media/Noor_Mohamed_Hired_Certificate.92df83ff.pdf";